import { Dispatch } from 'redux';
import { putNotification } from '@qwealth/qdata';

export type PostAttachment = {
  name: string;
  content: string;
};

export const encodeFilesAsBase64 = (files: File[]): Promise<PostAttachment[]> =>
  Promise.all(
    files.map(
      file =>
        new Promise<PostAttachment>((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve({ name: file.name, content: reader.result as string });
          reader.onerror = reject;
          reader.readAsDataURL(file);
        }),
    ),
  );

export const dispatch207Warning = (message: string | undefined, dispatch: Dispatch, status?: number): void => {
  const resolvedStatus = status ?? (message ? 207 : 200);
  if (resolvedStatus === 207 && message) {
    dispatch(putNotification(message, 'Warning'));
  }
};
